import './User.scss';

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as storage from '../utils/storage';
import { buildUrl } from '../utils/helper';
import { showMsg } from '../utils/logger';
import { get, put } from '../utils/requests';
import Slide from '../animation/Slide';
import ManualWrapper from './ManualWrapper';
import { Notifications, NotificationDialog } from './Notifications';
import BadgeContainer from '../BadgeContainer';
import $ from 'jquery';
import { useNavigate } from 'react-router';
import { useRequestNavigation } from '../utils/BlockerProvider';
import { SafeSVG } from '../svg/SafeSVG';

// SignalR
window.jQuery = $;
require('signalr');
export let _connection;

/**
 * User component
 * @module
 * @param {object} [uzivatel] - User object
 * @param {element} [brand] - Brand element
 * @param {func} onSignOut - Function invoked on sign out
 * @param {element} [userInfo] - User info element
 * @param {func} [getManual] - Function to get manual
 * @param {func} [getListManual] - Function to get manual list
 * @param {manualProps} [manualProps] - Props for manual
 */
const User = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const requestNavigation = useRequestNavigation();
  const [showInfo, setShowInfo] = useState(false);
  const [showNotifikacie, setShowNotifikacie] = useState(false);
  const [isManualDialogOpen, setIsManualDialogOpen] = useState(false);
  const [isManualListOpen, setIsManualListOpen] = useState(false);
  const [isManualCustomOpen, setIsManualCustomOpen] = useState(false);
  const [isNotifDialogOpen, setIsNotifDialogOpen] = useState(false);
  const [unreadedNotifs, setUnreadedNotifs] = useState({ TotalRecords: 0, Items: [] });

  const handleInfo = () => {
    setShowInfo(true);
  };

  const handleCloseInfo = () => {
    setShowInfo(false);
  };

  const handleManualDialogClose = () => {
    setIsManualDialogOpen(false);
  };

  const handleManualListClose = () => {
    setIsManualListOpen(false);
  };

  const handleManualCustomClose = () => {
    setIsManualCustomOpen(false);
  };

  // rozhodnutie ci sa pouzije dialog pre zobrazenie jedneho manualu
  // alebo manualList pre viacero manualov
  // alebo manualu s custom obsahom
  const handleNapoveda = () => {
    const manualProps = props.manualProps;

    if (manualProps && manualProps.hasList) {
      setIsManualListOpen(true);
    } else if (manualProps && manualProps.hasCustom) {
      setIsManualCustomOpen(true);
    } else {
      setIsManualDialogOpen(true);
    }
  };

  const handleSpravy = () => {
    if (props.getMessages) {
      return props.getMessages();
    }
  };

  const handleNotifikacie = () => {
    setShowNotifikacie(true);
  };

  const handleCloseNotifikacie = () => {
    setShowNotifikacie(false);
  };

  const handleLogout = () => {
    if (String(window?.config?.enableNotifications)?.trim()?.toLowerCase() === "true") {
      _connection.stop(false, true);
    }
    requestNavigation("/", () => {
      navigate("/", { state: { skipBlocker: true } });
      storage.removeUser();
      props.onSignOut();
    });

  };

  const buildInicialy = () => {
    const { uzivatel } = props;
    if (uzivatel && uzivatel.CeleMeno && uzivatel.Skratka) {
      return (
        <>
          <div className='fullname'>{uzivatel.CeleMeno}</div>
          <div className='shortcut'>{uzivatel.Skratka}</div>
        </>
      );
    } else if (uzivatel && !uzivatel.Skratka && uzivatel.CeleMeno) {
      let initials = (uzivatel.CeleMeno.split(' ').map(x => { return x.substring(0, 1); })).join("");
      return (
        <>
          <div className='fullname'>{uzivatel.CeleMeno}</div>
          <div className='shortcut'>{initials}</div>
        </>
      );
    }
    return (
      <>
        <div className='shortcut'>{uzivatel && uzivatel.Skratka ? uzivatel.Skratka : 'X'}</div>
      </>
    );
  };

  const { uzivatel } = props;

  const infoOkno = (
    <div className="info-okno">
      <div className="nav_initials">
        <div className="inicialization-icone">
          {buildInicialy()}
        </div>
      </div>
      <div className="example-2">
        {uzivatel && uzivatel.CeleMeno &&
          <div className="meno-user">
            {uzivatel.CeleMeno}
          </div>
        }
        {uzivatel && !uzivatel.CeleMeno &&
          <div className="meno-user">
            {uzivatel.Meno} {uzivatel.Priezvisko}
          </div>
        }
        {props.userInfo}
      </div>
      <div className="nav_button_logout">
        <div className="logout" onClick={handleLogout}>
          Odhlásiť sa
        </div>
      </div>
    </div>
  );

  const notifikacieOkno = () => {
    if (props.getNotifications) {
      return props.getNotifications();
    }
    else {
      return <Notifications unreadedNotifs={unreadedNotifs} getUnreadNotifications={getUnreadNotifications} onOpen={handleOpenNotifDialog} markAllAsRead={markAllAsRead} />;
    }
  };

  // Ziska neprecitane notifikacie
  const getUnreadNotifications = async () => {
    try {
      const notifs = await get('/api/meta/notif?unreadOnly=true&page=1');
      setUnreadedNotifs(notifs.Data);
    } catch (error) {
      dispatch(showMsg("Nepodarilo sa získať zoznam notifikácií", "warning"));
    }
  };

  // Oznacit vsetky ako precitane
  const markAllAsRead = async () => {
    await put(`/api/meta/notif/read`);
    await getUnreadNotifications();
    //await getNotifications();
  };


  // Notifikacna sprava, bez ulozenia do DB
  const handleNotificationMessage = (msg) => {
    dispatch(showMsg(msg.message, msg.notifTyp));
  };

  // Notifikacia, s ulozenim do DB
  const handleNotification = async (msg) => {
    dispatch(showMsg(msg.message, msg.notifTyp));
    await getUnreadNotifications();
  };

  // Prihlasenie sa na odber notifikacii
  const connectToNotificationHub = () => {
    try {
      _connection = $.hubConnection();
      let hub = _connection.createHubProxy("notificationHub");
      hub.on('notificationMessage', handleNotificationMessage);
      hub.on('notification', handleNotification);
      hub.on('remoteLogOut', handleLogout);

      _connection.url = `${window.config.url}/hub`;
      _connection.qs = { "token": storage.getUser().Token };
      // _connection.logging = true;
      _connection.start();
    } catch (error) {
      dispatch(showMsg("Nepodarilo sa prihlásiť k odberu notifikácií", "warning"));
    }
  };

  const handleOpenNotifDialog = () => setIsNotifDialogOpen(true);
  const handleCloseNotifDialog = async () => {
    setIsNotifDialogOpen(false);
    await getUnreadNotifications();
  };

  useEffect(() => {
    if (String(window?.config?.enableNotifications)?.trim()?.toLowerCase() === "true") {
      connectToNotificationHub();
      getUnreadNotifications();
    }
  }, []); // eslint-disable-line

  return (
    <div className="nav-user">
      <div className="nav-icon" onClick={props.handleOpenSettings}>
        <SafeSVG alt="Nastavenia" src={buildUrl('assets/icons/nav/setting.svg')} />
      </div>
      {(props.getManual || props.getListManual) &&
        <div className="nav-icon" onClick={handleNapoveda}>
          <SafeSVG alt="Používateľské príručky" src={buildUrl('assets/icons/nav/manual.svg')} />
        </div>
      }
      {(props.getMessages) &&
        <div className="nav-icon" onClick={handleSpravy}>
          <SafeSVG alt="Správy" src={buildUrl('assets/icons/nav/spravy.svg')} />
        </div>
      }
      <div className="nav-icon" onClick={handleNotifikacie}>
        {unreadedNotifs?.TotalRecords > 0 ? (
          <BadgeContainer themeColor={"error"} content={unreadedNotifs?.TotalRecords} size={"small"} cutoutBorder={false} align={{ horizontal: "end", vertical: "top" }}>
            <SafeSVG alt="Notifikácie" src={buildUrl('assets/icons/nav/zvoncek.svg')} />
          </BadgeContainer>
        ) : (
          <SafeSVG alt="Notifikácie" src={buildUrl('assets/icons/nav/zvoncek.svg')} />
        )}
      </div>
      <div className="inicialy-user" onClick={handleInfo}>
        {buildInicialy()}
      </div>
      <Slide isOpen={showNotifikacie} onClose={handleCloseNotifikacie}>{notifikacieOkno()}</Slide>
      <Slide isOpen={showInfo} onClose={handleCloseInfo}>{infoOkno}</Slide>
      {props.manualProps &&
        <ManualWrapper
          manualProps={props.manualProps}
          getManual={props.getManual}
          getListManual={props.getListManual}
          isManualOpen={isManualDialogOpen}
          onManualClose={handleManualDialogClose}
          isListOpen={isManualListOpen}
          onListClose={handleManualListClose}
          isCustomOpen={isManualCustomOpen}
          onCustomClose={handleManualCustomClose}
        />
      }
      {isNotifDialogOpen && (
        <NotificationDialog
          isOpen={isNotifDialogOpen}
          onClose={handleCloseNotifDialog}
          getUnreadNotifications={getUnreadNotifications}
          unreadCount={unreadedNotifs?.TotalRecords ?? 0}
        />
      )}
    </div>
  );
};

User.propTypes = {
  uzivatel: PropTypes.object,
  onSignOut: PropTypes.func.isRequired,
  userInfo: PropTypes.element,
  getManual: PropTypes.func,
  getListManual: PropTypes.func,
  getMessages: PropTypes.func,
  getNotifications: PropTypes.func,
  manualList: PropTypes.element,
  manualProps: PropTypes.shape({
    hasList: PropTypes.bool.isRequired,
    hasCustom: PropTypes.bool,
    manualCustom: PropTypes.arrayOf(PropTypes.object),
    listManual: PropTypes.object,
    user: PropTypes.object,
    manualBlob: PropTypes.object,
    manualFileName: PropTypes.string,
    manualTitle: PropTypes.string,
    manualList: PropTypes.arrayOf(PropTypes.object),
    manualListData: PropTypes.array,
    manualListDataMap: PropTypes.object
  })
};

export default User;
